export const player4 = 'https://embed.wirewax.com';
export const error = '/error';
